import { Routes, Route } from "react-router-dom";
import Layout from "../common/component/Layout";
import Home from "../pages/home";
import Career from "../pages/career";
import Services from "../pages/services";
import ContactUs from "../pages/contact-us";
import Blog from "../pages/blog";
import BlogDetail from "../pages/single-blog";
import About from "../pages/about-us";
import AndroidDevelopment from "../pages/android-development";
import CustomDevelopment from "../pages/custom-development";
import PosDevelopment from "../pages/pos-development";

import WebDevelopment from "../pages/website-development";
import UIUX from "../pages/uiux-designer";
import Crm from "../pages/crm-development";

import NotFound from "../pages/notFound";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="career" element={<Career />} />
        <Route path="services" element={<Services />} />
        <Route path="contact-us" element={<ContactUs />} />
        <Route path="about-us" element={<About />} />
        <Route path="android-development" element={<AndroidDevelopment />} />
        <Route path="crm-development" element={<Crm />} />

        <Route
          path="custom-software-development"
          element={<CustomDevelopment />}
        />
        <Route path="point-of-sale-development" element={<PosDevelopment />} />

        <Route path="website-development" element={<WebDevelopment />} />
        <Route path="uiux-designer" element={<UIUX />} />

        <Route path="blogs" element={<Blog />} />
        <Route path="blogs/:slug" element={<BlogDetail />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
